module.exports = __webpack_public_path__ + "static/media/node-js.ed3ec5db.svg";